import React from "react";
import { Link } from "react-router-dom";

const HomePage: React.FC = () => {
    return (
        <>
            <h1>Home</h1>
            <Link to="/documents">Got to documents</Link>
        </>
    );
}

export default HomePage;